angular.module('unica_invitation_transfer_event.invitation_transfer_event_services', []);